export default __webpack_public_path__ + "static/media/icon-flag-austria.22162e47.svg";